import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex';
import TabelToolBar from './components/TabelToolBar';
import EditTable from './components/EditTable.vue';
export default {
  components: {
    TabelToolBar: TabelToolBar,
    EditTable: EditTable
  },
  methods: _objectSpread(_objectSpread({}, mapActions('Portal/Announcement', ['setOrderStatu'])), {}, {
    onSave_OuterBoxLabelManagement: function onSave_OuterBoxLabelManagement() {
      this.$refs.EditTable.handleSaveData(); // console.log(this.$refs.EditTable.handleSaveData())
      // try {
      // }
      // setTimeout(() => {
      //   this.setOrderStatu('listShow')
      // }, 1000)
    },
    AddNotice: function AddNotice() {
      console.log(this.$refs.EditTable.mainform);
      this.$refs.EditTable.mainform = {
        ID: '',
        CREATETIME: '',
        CREATORID: '',
        //
        TYPE_ID: 1,
        // 发布方式
        ISSUE_DATE: '',
        // 发布日期
        THEME: '',
        // 公告主题
        CONTENT: '',
        // 公告内容
        ATTACHMENT_URL: '',
        // 附件地址
        ATTACHMENT_NAME: '',
        // 附件文件名
        FILE_CODE: '',
        // 文档编号
        IS_SHOW_INDEX: 1,
        // 是否在首页显示
        CODE: '',
        // 单据编号
        ORGANIZE_ID: 10
      };
      this.setOrderStatu('addOrder');
    }
  })
};